<template>
    <v-layout row justify-center v-if="formData.id">
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card class="content" style="background: #f4f4f4">
                <v-toolbar flat dense dark color="primary" class="fix-top" flat dense>
                    <v-btn icon depressed dark @click="$emit('hide')">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title class="subheading">Order Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <!--<v-btn dark flat @click="$emit('hide')">Save</v-btn>-->
                    </v-toolbar-items>
                </v-toolbar>
                <div style="padding-bottom: 125px;">
                    <v-card flat class="mt-5">
                        <div style="display: flex; padding: 10px;">
                            <div style="align-self: start;">
                                <v-icon>pin_drop</v-icon>
                            </div>
                            <div style="margin-left: 10px;">
                                <div class="text-black text-bold">Delivery Address</div>
                                <div class="text-black">{{formData.order_address.name}}</div>
                                <div class="text-black">{{formData.order_address.mobile_number}}</div>
                                <div class="text-dark">{{formData.order_address.address}} {{formData.order_address.barangay}}
                                    {{formData.order_address.city}} {{formData.order_address.province}}
                                    {{formData.order_address.region}} {{formData.order_address.postal}}</div>

                                <div v-if="formData.status.toLowerCase() == 'pick_up'">
                                    <div class="text-black text-bold mt-2">Pick Up Details</div>
                                    <div class="text-black">{{formData.shop.phone}}</div>
                                    <div class="text-black">{{`${formData.branch.address}`}}</div>
                                    <!--${formData.branch.barangay} ${formData.branch.city} ${formData.branch.province} ${formData.branch.region} ${formData.branch.postal_code}-->
                                </div>
                            </div>
                        </div>

                    </v-card>

                    <v-card flat class="my-2">
                        <v-container class="mb-2">
                            <v-card-title class="pa-0">
                                <div class="d-flex align-center">
                                    <div style="align-self: start">
                                        <v-icon>mdi-package-variant-closed</v-icon>
                                    </div>

                                    <div  style="display: flex; flex-direction: column; margin-left: 10px;">
                                        <p class="text-black text-bold ma-0">Package {{formData.id}}</p>
                                        <div class="text-black">Sold by {{formData.branch.name}}</div>
                                    </div>

                                </div>
                                <v-spacer></v-spacer>
                                <div class="status pending">{{formData.status}}</div>
                            </v-card-title>

                            <v-container class="px-0 mb-3" v-for="(item, index) in formData.order_items">
                                <div class="item-product-order-grid">
                                    <div class="item-product-order-grid__image pa-1">
                                        <v-img aspect-ratio="1" contain :src="item.branch_variation.variation.product.galleries[0].url_thumbnail"></v-img>
                                    </div>
                                    <div>
                                        <div class="text-black min-height-48">
                                            {{item.branch_variation.variation.product.name}}
                                            <div style="display: inline-block" v-if="typeof item.branch_variation.variation.variation_options[0] !== 'undefined'">
                                                ({{item.branch_variation.variation.variation_options[0].name}})
                                            </div>
                                            <div v-if="typeof item.branch_variation.variation.variation_options[1] !== 'undefined'">
                                                ( {{item.branch_variation.variation.variation_options[1].name}})
                                            </div>
                                        </div>
                                        <!--<div class="status pending">Packing</div>-->
                                    </div>
                                    <div>
                                        <div class="text-black text-right">x{{item.quantity}}</div>
                                        <h3 class="text-right red--text">&#8369; {{numberWithCommas(item.price)}}</h3>
                                    </div>
                                </div>
                                <!--<div class="action-buttons text-right mt-2">-->
                                <!--<v-btn outline small color="primary">Track Package</v-btn>-->
                                <!--<v-btn outline small color="primary">Message Seller</v-btn>-->
                                <!--</div>-->
                            </v-container>
                        </v-container>
                    </v-card>

                    <v-card flat>
                        <v-container class="mb-2">
                            <h3 v-if="formData.tracking_number" class="text-bold">Tracking #{{formData.tracking_number}}</h3>
                            <!--<small class="text-dark">Placed on {{dateFormatted(new Date(formData.created_at))}}</small>-->

                            <div class="mt-3">
                                <div class="d-flex">
                                    <div class="text-bold">Subtotal</div>
                                    <v-spacer></v-spacer>
                                    <div class="text-bold text-right">&#8369; {{numberWithCommas(formData.subtotal)}}</div>
                                </div>
                                <div class="d-flex">
                                    <div class="text-bold">Shipping fee</div>
                                    <v-spacer></v-spacer>
                                    <div class="text-bold text-right">&#8369; {{numberWithCommas(formData.shipping_fee)}}</div>
                                </div>
                            </div>

                            <div class="text-right mt-2">
                                <small class="text-dark">{{formData.order_items.length > 1 ?
                                    `${formData.order_items.length} items` : '1 item'}} </small>
                                <div class="text-bold">Total(VAT Included): &nbsp;<span class="text-red">&#8369;
                                {{numberWithCommas(formData.total)}} </span></div>
                                <!--<small class="text-dark">Will be paid by: Cash on Delivery</small>-->
                            </div>
                        </v-container>
                    </v-card>

                    <!-- cancelled remarks -->
                    <v-card flat v-if="formData.cancel_reason">
                        <v-container>
                            <h3>Remarks</h3>
                            <p style="margin-bottom: 0;">{{ formData.cancel_reason }}</p>
                        </v-container>
                    </v-card>

                    <v-card flat v-if="formData.status.toLowerCase() == 'pick_up'">

                        <v-container>
                            <v-layout row justify-center class="mb-2">
                                <div class="text-bold">Pick up tracking # {{formData.tracking_number}}</div>
                            </v-layout>
                            <v-img :src="`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${formData.tracking_number}`"
                                   aspect-ratio="1" class="grey lighten-2" width="200" style="margin: auto;">
                                <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                            </v-img>
                        </v-container>

                    </v-card>
                </div>
                <div class="footer">
                    <v-card flat>
                        <v-layout column  class="pa-3">
                            <v-btn v-show="formData.tracking_number != ''" @click="$emit('goToLogistic', formData.tracking_number)" depressed color="secondary" block >
                                <v-icon>local_shipping</v-icon>
                                <span class="ml-2">Shipping Information</span>
                            </v-btn>
                            <v-btn @click="print" depressed color="secondary" block >
                                <v-icon>mdi-download</v-icon>
                                <span class="ml-2">Download</span>
                            </v-btn>
                            <v-btn v-if="formData.invoice_number" @click="viewInvoice" depressed color="secondary" block>
                                <span class="ml-2">View Invoice</span>
                            </v-btn>
                        </v-layout>
                    </v-card>

                </div>

            </v-card>


        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "PurchaseDetails",
        props: {
            dialog: false,
            formData: {},
            showBranchAddress: false,
        },

        watch: {
            formData: {
                handler(newVal) {

                },
                deep: true,
            }
        },
        data() {
            return {
                notifications: false,
                sound: true,
                widgets: false,
                doc: null,
                specialElementHandlers: null,
            }
        },
        methods: {
            print() {
                window.print();
            },
            viewInvoice()
            {
                window.open(process.env.VUE_APP_URL + 'order/print_invoice/' + this.formData.id, '_blank');
            }
        },
        mounted() {

        }
    }

</script>

<style lang="scss">

    @import "../../scss/app.scss";

    // .my-orders {
    //     background-color: $bg;
    // }

    .status {
        &.pending {
            color: #ff6347;
        }
    }

    .item-product-order-grid {
        display: grid;
        grid-template-columns: 100px 150px auto;
        grid-gap: 8px;

        .item-product-order-grid__image {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                max-width: 100%;
                height: auto;
            }
        }
    }

    .fix-top{
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .footer {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 99;
        /*background-color: red;*/
        /*color: white;*/
        /*text-align: center;*/
    }
</style>
